<!--The content below is only a placeholder and can be replaced.-->
<router-outlet></router-outlet>
<div kendoDialogContainer></div>